const SITE_URL = 'https://magicparktimes.com';

const PARK_NAMES = {
  'disneyland-paris': 'Disneyland Paris',
  'walt-disney-studios': 'Walt Disney Studios',
  'disneyland-california': 'Disneyland California',
  'disney-california-adventure': 'Disney California Adventure',
  'magic-kingdom': 'Magic Kingdom',
  epcot: 'Epcot',
  'hollywood-studios': 'Hollywood Studios',
  'animal-kingdom': 'Animal Kingdom',
  'tokyo-disneyland': 'Tokyo Disneyland',
  'tokyo-disneysea': 'Tokyo DisneySea',
  'shanghai-disneyland': 'Shanghai Disneyland',
  'hong-kong-disneyland-park': 'Hong Kong Disneyland',
  'universal-studios': 'Universal Studios Florida',
  'islands-of-adventure': 'Islands of Adventure',
  'universal-studios-california': 'Universal Studios California',
  'universal-studios-beijing': 'Universal Studios Beijing',
  'universal-studios-singapore': 'Universal Studios Singapore',
  efteling: 'Efteling',
  phantasialand: 'Phantasialand',
  'europa-park': 'Europa-Park',
  toverland: 'Toverland',
  'walibi-belgium': 'Walibi Belgium',
  'walibi-holland': 'Walibi Holland',
  'walibi-rhone-alpes': 'Walibi Rhône-Alpes',
  'parc-asterix': 'Parc Astérix',
  futuroscope: 'Futuroscope',
  'le-pal': 'Le Pal',
  nigloland: 'Nigloland',
  'plopsaland-de-panne': 'Plopsaland De Panne',
  gardaland: 'Gardaland',
  mirabilandia: 'Mirabilandia',
  'movie-park-germany': 'Movie Park Germany',
  'parque-de-atracciones-de-madrid': 'Parque de Atracciones de Madrid',
  portaventura: 'PortAventura',
  'ferrari-land': 'Ferrari Land',
  energylandia: 'Energylandia',
  'grona-lund': 'Gröna Lund',
  bellewaerde: 'Bellewaerde',
  bobbejaanland: 'Bobbejaanland',
  'seaworld-orlando': 'SeaWorld Orlando',
  'busch-gardens-tampa': 'Busch Gardens Tampa',
  'legoland-florida': 'LEGOLAND Florida',
  'legoland-deutschland': 'LEGOLAND Deutschland',
  'knotts-berry-farm': "Knott's Berry Farm",
  'alton-towers': 'Alton Towers',
  carowinds: 'Carowinds',
  kennywood: 'Kennywood',
  'heide-park': 'Heide Park',
  knoebels: 'Knoebels',
  'silver-dollar-city': 'Silver Dollar City',
  'la-ronde': 'La Ronde',
  'kings-island': 'Kings Island',
  hersheypark: 'Hersheypark',
  'lotte-world': 'Lotte World',
  'six-flags-qiddiyacity': 'Six Flags Qiddiya City',
  'typhoon-lagoon': 'Typhoon Lagoon',
  'blizzard-beach': 'Blizzard Beach',
  rulantica: 'Rulantica',
  traumatica: 'Traumatica',
  'epic-universe': 'Epic Universe',
  'volcano-bay': "Universal's Volcano Bay",
};

const STATIC_ROUTE_META = {
  '/': {
    title: "Magic Park Times - Temps d'attente en direct pour 45+ parcs à thème",
    description: "Temps d'attente en direct pour 45+ parcs à thème : Europa-Park, Efteling, Parc Astérix, Phantasialand, PortAventura, Gardaland, Disneyland Paris, Universal Studios et bien plus. Files d'attente en temps réel, horaires et prévisions d'affluence.",
    image: `${SITE_URL}/images/og/og-home.jpg`,
  },
  '/shows': {
    title: 'Spectacles Disneyland Paris - Horaires en direct | Magic Park Times',
    description: 'Horaires des spectacles, parades et rencontres de Disneyland Paris en temps réel pour organiser votre journée sans perdre le fil.',
    image: `${SITE_URL}/images/og/og-shows.jpg`,
  },
  '/restaurants': {
    title: 'Restaurants Disneyland Paris - Guide & Infos | Magic Park Times',
    description: 'Guide des restaurants et points de restauration de Disneyland Paris avec infos pratiques pour choisir où manger pendant votre visite.',
    image: `${SITE_URL}/images/og/og-restaurants.jpg`,
  },
  '/parks': {
    title: 'Tous les parcs - Magic Park Times',
    description: "Explorez les parcs suivis par Magic Park Times en Europe, Amérique et Asie, avec accès rapide aux temps d'attente, horaires et infos utiles.",
    image: `${SITE_URL}/images/og/og-parks.jpg`,
  },
  '/about': {
    title: 'A propos - Magic Park Times',
    description: "Découvrez Magic Park Times, la plateforme de référence pour suivre les temps d'attente et préparer vos visites dans les parcs à thème.",
    image: `${SITE_URL}/images/og/og-about.jpg`,
  },
  '/contact': {
    title: 'Contact - Magic Park Times',
    description: "Contactez l'équipe Magic Park Times pour une question, une suggestion ou un signalement lié aux données des parcs.",
    image: `${SITE_URL}/images/og/og-contact.jpg`,
  },
  '/support-us': {
    title: 'Nous soutenir - Magic Park Times',
    description: 'Soutenez Magic Park Times pour aider à maintenir les données live, les outils de visite et les améliorations de la plateforme.',
    image: `${SITE_URL}/images/og/og-support-us.jpg`,
  },
  '/map': {
    title: 'Carte interactive - Magic Park Times',
    description: "Carte interactive Magic Park Times pour localiser attractions, restaurants et services avec les données utiles de votre visite.",
    image: `${SITE_URL}/images/og/og-map.jpg`,
  },
  '/my-pass': {
    title: 'Mon Pass Annuel - Magic Park Times',
    description: 'Suivez vos informations de pass annuel et gardez vos outils de visite à portée de main sur Magic Park Times.',
    image: `${SITE_URL}/images/og/og-home.jpg`,
  },
  '/asterix-pass': {
    title: 'Pass Parc Astérix - Magic Park Times',
    description: 'Retrouvez les informations utiles autour du pass Parc Astérix et préparez votre visite avec Magic Park Times.',
    image: `${SITE_URL}/images/og/og-parc-asterix.jpg`,
  },
  '/login': {
    title: 'Connexion - Magic Park Times',
    description: 'Connectez-vous à votre compte Magic Park Times.',
    image: `${SITE_URL}/images/og/og-login.jpg`,
  },
  '/signup': {
    title: 'Inscription - Magic Park Times',
    description: 'Créez votre compte Magic Park Times.',
    image: `${SITE_URL}/images/og/og-signup.jpg`,
  },
  '/dispatch-max': {
    title: 'Dispatch Max - Magic Park Times',
    description: 'Accédez à Dispatch Max depuis Magic Park Times.',
    image: `${SITE_URL}/images/og/og-dispatch-max.jpg`,
  },
  '/deanrell-soundbox': {
    title: 'Deanrell Soundbox - Magic Park Times',
    description: 'Profitez de Deanrell Soundbox sur Magic Park Times.',
    image: `${SITE_URL}/images/og/og-deanrell-soundbox.jpg`,
  },
  '/studios': {
    title: "Walt Disney Studios - Temps d'attente en direct | Magic Park Times",
    description: "Temps d'attente Walt Disney Studios en direct : files d'attente, horaires et infos pratiques pour organiser votre visite.",
    image: `${SITE_URL}/images/og/og-walt-disney-studios.jpg`,
  },
};

const NOINDEX_PATH_PREFIXES = [
  '/admin',
  '/login',
  '/signup',
  '/profile',
  '/dashboard',
  '/auth/callback',
  '/email-verified',
  '/dispatch-max',
  '/tv',
  '/splash-test',
  '/deanrell-soundbox',
];

const RESERVED_NON_PARK_SEGMENTS = new Set([
  'admin',
  'api',
  'about',
  'contact',
  'support-us',
  'parks',
  'shows',
  'restaurants',
  'map',
  'login',
  'signup',
  'dispatch-max',
  'deanrell-soundbox',
  'my-pass',
  'asterix-pass',
  'tv',
  'offline',
  'sitemap.xml',
]);

const PARK_GEO = {
  'disneyland-paris': { lat: 48.8722, lng: 2.7758 },
  'walt-disney-studios': { lat: 48.8685, lng: 2.7808 },
  efteling: { lat: 51.65, lng: 5.0474 },
  phantasialand: { lat: 50.7984, lng: 6.8799 },
  'europa-park': { lat: 48.2661, lng: 7.7219 },
  rulantica: { lat: 48.2661, lng: 7.7219 },
  traumatica: { lat: 48.2661, lng: 7.7219 },
  'parc-asterix': { lat: 49.1342, lng: 2.5707 },
  futuroscope: { lat: 46.6667, lng: 0.3667 },
  'le-pal': { lat: 46.5089, lng: 3.635 },
  nigloland: { lat: 48.2594, lng: 4.6144 },
  'walibi-belgium': { lat: 50.6961, lng: 4.5906 },
  'walibi-holland': { lat: 52.4401, lng: 5.7675 },
  'walibi-rhone-alpes': { lat: 45.6203, lng: 5.5717 },
  'plopsaland-de-panne': { lat: 51.0791, lng: 2.602 },
  toverland: { lat: 51.3977, lng: 5.9827 },
  gardaland: { lat: 45.4567, lng: 10.7139 },
  mirabilandia: { lat: 44.3381, lng: 12.2631 },
  portaventura: { lat: 41.0864, lng: 1.1559 },
  'ferrari-land': { lat: 41.0864, lng: 1.1559 },
  energylandia: { lat: 49.9706, lng: 19.2019 },
  'grona-lund': { lat: 59.3233, lng: 18.0979 },
  bellewaerde: { lat: 50.8472, lng: 2.9472 },
  bobbejaanland: { lat: 51.1978, lng: 4.9056 },
  'movie-park-germany': { lat: 51.6236, lng: 6.9728 },
  'parque-de-atracciones-de-madrid': { lat: 40.4114, lng: -3.7494 },
  'thorpe-park': { lat: 51.4036, lng: -0.5125 },
  'universal-studios': { lat: 28.4744, lng: -81.4687 },
  'islands-of-adventure': { lat: 28.4741, lng: -81.4715 },
  'epic-universe': { lat: 28.4414, lng: -81.4487 },
  'universal-studios-california': { lat: 34.1381, lng: -118.3534 },
  'universal-studios-beijing': { lat: 39.8633, lng: 116.68 },
  'seaworld-orlando': { lat: 28.4115, lng: -81.4617 },
  'busch-gardens-tampa': { lat: 28.0372, lng: -82.4194 },
  'legoland-florida': { lat: 27.9894, lng: -81.6867 },
  'knotts-berry-farm': { lat: 33.8443, lng: -117.9988 },
  'disneyland-california': { lat: 33.8121, lng: -117.919 },
  'disney-california-adventure': { lat: 33.8068, lng: -117.921 },
  'magic-kingdom': { lat: 28.4177, lng: -81.5812 },
  epcot: { lat: 28.3747, lng: -81.5494 },
  'hollywood-studios': { lat: 28.3578, lng: -81.5584 },
  'animal-kingdom': { lat: 28.3587, lng: -81.5908 },
  'typhoon-lagoon': { lat: 28.3653, lng: -81.5358 },
  'blizzard-beach': { lat: 28.3489, lng: -81.5748 },
  'tokyo-disneyland': { lat: 35.6329, lng: 139.8804 },
  'tokyo-disneysea': { lat: 35.6267, lng: 139.8851 },
  'shanghai-disneyland': { lat: 31.1433, lng: 121.658 },
  'hong-kong-disneyland-park': { lat: 22.313, lng: 114.0413 },
  'lotte-world': { lat: 37.5111, lng: 127.098 },
  'six-flags-qiddiyacity': { lat: 24.4539, lng: 46.485 },
};

const POPULAR_PARKS_FOR_ITEMLIST = [
  { slug: 'europa-park', name: 'Europa-Park' },
  { slug: 'efteling', name: 'Efteling' },
  { slug: 'parc-asterix', name: 'Parc Astérix' },
  { slug: 'phantasialand', name: 'Phantasialand' },
  { slug: 'disneyland-paris', name: 'Disneyland Paris' },
  { slug: 'portaventura', name: 'PortAventura' },
  { slug: 'gardaland', name: 'Gardaland' },
  { slug: 'universal-studios', name: 'Universal Studios Florida' },
  { slug: 'futuroscope', name: 'Futuroscope' },
  { slug: 'energylandia', name: 'Energylandia' },
  { slug: 'epic-universe', name: 'Epic Universe' },
  { slug: 'walibi-belgium', name: 'Walibi Belgium' },
];

function normalizePath(inputPath) {
  if (!inputPath || inputPath === '/') {
    return '/';
  }

  const withLeadingSlash = inputPath.startsWith('/') ? inputPath : `/${inputPath}`;
  return withLeadingSlash.replace(/\/+$/, '') || '/';
}

function titleCaseFromSlug(slug) {
  return String(slug || '')
    .split('-')
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ');
}

function parseSitemapRoutes(xml) {
  const locMatches = String(xml || '').match(/<loc>(.*?)<\/loc>/g) || [];
  return locMatches
    .map((tag) => tag.replace('<loc>', '').replace('</loc>', '').trim())
    .map((urlString) => {
      try {
        const url = new URL(urlString);
        return normalizePath(url.pathname);
      } catch {
        return null;
      }
    })
    .filter(Boolean);
}

function collectSeoRoutePaths(sitemapXml) {
  const routes = new Set(['/']);
  Object.keys(STATIC_ROUTE_META).forEach((routePath) => routes.add(normalizePath(routePath)));
  parseSitemapRoutes(sitemapXml).forEach((routePath) => routes.add(routePath));
  routes.add('/portaventura/ferrari-land');
  return Array.from(routes).sort((a, b) => a.localeCompare(b));
}

function shouldNoIndex(routePath) {
  const normalized = normalizePath(routePath);
  return NOINDEX_PATH_PREFIXES.some((prefix) => normalized.startsWith(prefix))
    || normalized.endsWith('/tv')
    || normalized.includes('/tv/');
}

function getStaticOgImageForPath(routePath) {
  const staticMeta = STATIC_ROUTE_META[normalizePath(routePath)];
  return staticMeta?.image || null;
}

function resolveOgImage(routePath, options = {}) {
  const normalized = normalizePath(routePath);
  const staticImage = getStaticOgImageForPath(normalized);
  if (staticImage) return staticImage;

  const segments = normalized.split('/').filter(Boolean);
  if (segments.length === 0) {
    return `${SITE_URL}/images/og/og-home.jpg`;
  }

  const ogImageExists = typeof options.ogImageExists === 'function'
    ? options.ogImageExists
    : () => true;

  if (segments[0] === 'portaventura' && segments[1] === 'ferrari-land' && ogImageExists('ferrari-land')) {
    return `${SITE_URL}/images/og/og-ferrari-land.jpg`;
  }

  const parkSlug = segments[0];
  if (ogImageExists(parkSlug)) {
    return `${SITE_URL}/images/og/og-${parkSlug}.jpg`;
  }

  return `${SITE_URL}/images/og/og-home.jpg`;
}

function buildDynamicMeta(routePath) {
  const normalized = normalizePath(routePath);
  const segments = normalized.split('/').filter(Boolean);
  const parkSlug = segments[0] || '';
  const parkName = PARK_NAMES[parkSlug] || titleCaseFromSlug(parkSlug);
  const subPage = segments[1] || null;

  if (segments.length === 1 && parkSlug && !RESERVED_NON_PARK_SEGMENTS.has(parkSlug)) {
    return {
      title: `Temps d'attente ${parkName} en Direct - Files d'attente & Horaires | Magic Park Times`,
      description: `Temps d'attente ${parkName} en direct : files d'attente attraction par attraction, horaires d'ouverture, affluence et conseils pour organiser votre visite.`,
    };
  }

  if (segments.length >= 2 && parkSlug && !RESERVED_NON_PARK_SEGMENTS.has(parkSlug)) {
    if (subPage === 'shows') {
      return {
        title: `Spectacles ${parkName} - Horaires en direct | Magic Park Times`,
        description: `Spectacles ${parkName} : horaires, programme du jour et événements à suivre pour planifier vos pauses entre deux attractions.`,
      };
    }

    if (subPage === 'restaurants') {
      return {
        title: `Restaurants ${parkName} - Guide & Infos | Magic Park Times`,
        description: `Restaurants ${parkName} : points de restauration, infos pratiques et repères utiles pour choisir où manger pendant votre journée.`,
      };
    }

    if (subPage === 'map') {
      return {
        title: `Carte interactive ${parkName} | Magic Park Times`,
        description: `Carte interactive ${parkName} avec les temps d'attente, les attractions, restaurants et services pour vous repérer dans le parc.`,
      };
    }
  }

  const fallback = STATIC_ROUTE_META['/'];
  return { title: fallback.title, description: fallback.description };
}

function getSeoMetaForRoute(routePath, options = {}) {
  const normalized = normalizePath(routePath);
  const staticMeta = STATIC_ROUTE_META[normalized];
  const dynamicMeta = staticMeta || buildDynamicMeta(normalized);
  const canonicalUrl = `${SITE_URL}${normalized === '/' ? '' : normalized}`;

  return {
    title: dynamicMeta.title,
    description: dynamicMeta.description,
    canonicalUrl,
    ogImage: resolveOgImage(normalized, options),
    noindex: shouldNoIndex(normalized),
  };
}

module.exports = {
  SITE_URL,
  PARK_NAMES,
  STATIC_ROUTE_META,
  NOINDEX_PATH_PREFIXES,
  RESERVED_NON_PARK_SEGMENTS,
  PARK_GEO,
  POPULAR_PARKS_FOR_ITEMLIST,
  normalizePath,
  parseSitemapRoutes,
  collectSeoRoutePaths,
  shouldNoIndex,
  getStaticOgImageForPath,
  resolveOgImage,
  buildDynamicMeta,
  getSeoMetaForRoute,
  titleCaseFromSlug,
};
